export const dateFormatter = new Intl.DateTimeFormat(undefined, {
  month: 'short',
  day: 'numeric',
});

/** Date and time, e.g. for "last updated" timestamps in tables. */
export const dateTimeFormatter = new Intl.DateTimeFormat(undefined, {
  year: '2-digit',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
});

/** Compact date + time, e.g. "last synced" stamps. */
export const shortDateTimeFormatter = new Intl.DateTimeFormat(undefined, {
  dateStyle: 'short',
  timeStyle: 'short',
});

/** Unambiguous day + month name, e.g. "04 Mar 2026", for dense admin lists. */
export const longDateFormatter = new Intl.DateTimeFormat(undefined, {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
});

/** `longDateFormatter` plus the time, for audit trails and submission stamps. */
export const longDateTimeFormatter = new Intl.DateTimeFormat(undefined, {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

/** `longDateTimeFormatter` down to the second, for workflow run timings. */
export const longDateTimeSecondsFormatter = new Intl.DateTimeFormat(undefined, {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
});

const dateRangeFormatter = new Intl.DateTimeFormat(undefined, {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
});

// Colons are illegal in Windows filenames, and the milliseconds dot reads as an extension separator
export function filenameTimestamp(date = new Date()) {
  return date.toJSON().replace(/[:.]/g, '-');
}

// Use `formatRange` or fallback if not supported by browser
export function formatDateRange(start: Date, end: Date) {
  if (dateRangeFormatter.formatRange) {
    return dateRangeFormatter.formatRange(start, end);
  } else {
    return `${dateRangeFormatter.format(start)} - ${dateRangeFormatter.format(end)}`;
  }
}
